module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"engine":"Engine","category":"Category","spec":"Spec","template":"Template","type":"Type"}}')
  delete Component.options._Ctor
}
